import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import store from './store';  // Adjust the import path as necessary
import App from './App';
import '@styles/global.css';
import queryClient from './utils/reactQueryClient';  // Adjust the import path as necessary
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
      <ToastContainer />
    </QueryClientProvider>
  </Provider>
);
